import { BASE_HREF } from "../constants";
import { selectElement } from "../utils/element-handlers.utils";
import $ from 'jquery';

function NewsletterFormComponent(formElement: HTMLElement) {
    const emailElement = formElement.querySelector('#newsletter-form-email') as HTMLInputElement | null;
    const restaurantIdElement = formElement.querySelector('#newsletter-form-restaurant') as HTMLSelectElement | null;
    const submitElement = formElement.querySelector('button[type="submit"]') as HTMLButtonElement | null;
    
    const errorEmailElement = formElement.querySelector('.n-newsletter-form-error#newsletter-form-email-error') as HTMLElement | null;
    const errorRestaurantIdElement = formElement.querySelector('.n-newsletter-form-error#newsletter-form-id-error') as HTMLElement | null;
    const successMessageElement = document.getElementById('newsletter-form-success-message') as HTMLElement | null;
    const successMessageLocationNameElement = document.getElementById('newsletter-form-location-name') as HTMLElement | null;

    if (emailElement && restaurantIdElement && submitElement) {
        var submitForm = function (email: string, id: string) {
            var url = BASE_HREF + '/subscribe';
            var body = {
                id: id,
                email: email
            };

            emailElement.setAttribute('disabled', 'disabled');
            restaurantIdElement.setAttribute('disabled', 'disabled');
            submitElement.setAttribute('disabled', 'disabled');

            $.ajax({
                type: 'POST',
                url: url,
                contentType: 'application/json',
                data: JSON.stringify(body),
                dataType: 'json',
                processData: false,
                success: function () {
                    var subscribedLocationName = restaurantIdElement.options[restaurantIdElement.selectedIndex].innerHTML.trim();

                    if (successMessageElement && successMessageLocationNameElement) {
                        formElement.style.display = 'none';
                        successMessageLocationNameElement.innerHTML = subscribedLocationName;
                        successMessageElement.style.display = 'flex';
                    }
                    else {
                        alert('Thank you for subscribing to ' + subscribedLocationName)
                    }
                },
                error: function (error) {
                    alert('Error');

                    emailElement.removeAttribute('disabled');
                    restaurantIdElement.removeAttribute('disabled');
                    submitElement.removeAttribute('disabled');
                }
            });
        };

        var validateEmail = (email: string) => {
            return Boolean(
                String(email)
                    .toLowerCase()
                    .match(
                        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                    )
            );
        };

        var validateId = function (id: string) {
            return Boolean(Number(id));
        };

        var validateForm = function () {
            var email = emailElement.value;
            var id = restaurantIdElement.value;

            if (validateId(id) && validateEmail(email)) {
                submitElement.classList.remove('n-disabled');
            }
            else {
                submitElement.classList.add('n-disabled');
            }
        };

        var setErrorMessages = function (emailIsValid: boolean, idIsValid: boolean) {
            if (errorEmailElement) {
                if (emailIsValid) {
                    errorEmailElement.style.display = 'none';
                }
                else {
                    errorEmailElement.style.display = 'block';
                }
            }

            if (errorRestaurantIdElement) {
                if (idIsValid) {
                    errorRestaurantIdElement.style.display = 'none';
                }
                else {
                    errorRestaurantIdElement.style.display = 'block';
                }
            }
        };

        validateForm();
        
        emailElement.addEventListener('input', function () {
            if (errorEmailElement) {
                errorEmailElement.style.display = 'none';
            }
            validateForm();
        });
        restaurantIdElement.addEventListener('change', function () {
            if (errorRestaurantIdElement) {
                errorRestaurantIdElement.style.display = 'none';
            }
            validateForm();
        });
        formElement.addEventListener('submit', function (event) {
            event.preventDefault();

            var email = emailElement.value;
            var id = restaurantIdElement.value;
            var emailIsValid = validateEmail(email);
            var idIsValid = validateId(id);

            setErrorMessages(emailIsValid, idIsValid);

            if (emailIsValid && idIsValid) {
                submitForm(email, id);
            }
        });
    }
}

export default function initNewsletterFormComponent() {
    selectElement('form#newsletter-form', NewsletterFormComponent)
}
